import TextWidget from './TextWidget'

export const customWidgets = {
  TextWidget: TextWidget,
}
